"use strict";

exports.__esModule = true;
exports.ViewableEvent = exports.AdvertEventHandler = void 0;
var _XmlValidation2 = require("../Parsers/XmlValidation");
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
/**
 * Enumeration of possible viewable events:
 * @enum {number}
 * @category Enumerations
 */
var ViewableEvent = Object.freeze({
  /** Indicates that an advert is viewable */
  VIEWABLE: 0,
  /** Indicates that an advert is not viewable */
  NOT_VIEWABLE: 1,
  /** Indicates that the viewable state of an ad is undetermined */
  VIEW_UNDETERMINED: 2
});

/**
 * AdvertEventHandler declares a set of methods that allow clients to provide event information to an advert.
 *
 * It is implemented by Advert and clients <b>must</b> call each method at the appropriate time so that
 * the SDK can signal analytics on behalf of the app.
 * @hideconstructor
 */
exports.ViewableEvent = ViewableEvent;
var AdvertEventHandler = /*#__PURE__*/function (_XmlValidation) {
  _inheritsLoose(AdvertEventHandler, _XmlValidation);
  function AdvertEventHandler() {
    return _XmlValidation.apply(this, arguments) || this;
  }
  var _proto = AdvertEventHandler.prototype;
  /** Indicates that a viewable event occurred for a linear advert.
   * Clients should call this method in order to fire the appropriate Viewable beacon.
   * @param {ViewableEvent} event the event, defined by the enum ViewableEvent.
   * @see {@link ViewableEvent}
   */
  _proto.onViewableEvent = function onViewableEvent(event) {
    throw new Error("Function must be overridden");
  }

  /** Indicates that an error occurred that is in the domain of the player / app. The SDK fires beacons for any `<Error>` URLs
   * defined for the advert.<br/>
   * @param {number} [errorCode] (optional) the error code value that should be used in the ERRORCODE macro substitution.
   * If 0 or no value is supplied then no substitution is made.
   */;
  _proto.onErrorEvent = function onErrorEvent(errorCode) {
    throw new Error("Function must be overridden");
  }

  /** Indicates that an impression event occurred for a non-linear advert.
   * Clients should call this method in order to fire impression beacons associated with the advert.
   *
   * <b>NOTE:</b> Clients should call this method only for adverts in a non-linear ad break. Calling this method
   * on a linear advert has no effect.
   */;
  _proto.onImpressionEvent = function onImpressionEvent() {
    throw new Error("Function must be overridden");
  };
  return AdvertEventHandler;
}(_XmlValidation2.XmlValidation);
exports.AdvertEventHandler = AdvertEventHandler;